module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Shuffle-fc7bc961b200dcee1df0e3b95009213b.svg";